export default __webpack_public_path__ + "static/media/profilephoto.959e58a0.webp";